import React from 'react';

import '/src/styles/index.css';
import styles from './styles.module.css';
import moment from 'moment-timezone';




const MailingArchive = ({spamsArchivedData}) => {

    return (
        <>
            <div className="card">
                {spamsArchivedData.length > 0 ? (
                    <>
                        {spamsArchivedData.map((data, index) => {
                            const message = JSON.parse(data.message);
                            const text = message.text;
                            const bot = data.bot_info;
                            let date = data.time_send

                            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; 
                            const momentDateTime = moment.tz(date, 'Europe/Paris');
                            const formattedDateTimeUserTimeZone = momentDateTime.clone().tz(userTimeZone).format('YYYY-MM-DD HH:mm'); 
                    
                            date = formattedDateTimeUserTimeZone;

                            return (
                                <div className={styles['mailing-item']} key={index}>
                                <h3 class={styles['mailing-title']}>Название спама: {data.name}</h3>
                                <div className={styles.container}>
                                    <div className={styles['mailing-item-desc']}>
                                        {!bot ? (
                                            <p className={styles.subtitle}>Данные бота неизвестны</p>
                                            ) : (
                                            <>
                                            { typeof bot === 'object' && Object.keys(bot).length > 1 ? (
                                               <div className={styles['data-wrapper']}>
                                                    <p className={styles.subtitle}>Рассылка выполнена несколькими ботами:</p>
                                                    {bot.map((item, index) => (
                                                        <div key={index}>
                                                            <p>{item.bot_name}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) 
                                            : typeof bot === 'object' ? (
                                                <div className={styles['data-wrapper']}>
                                                    <p className={styles.subtitle}>Рассылка от бота:</p>
                                                    {bot.map((item, index) => (
                                                        <div key={index}>
                                                            <p>{item.bot_name}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ): (
                                                <div>
                                                    <p className={styles.subtitle}>Данные бота неизвестны:</p>
                                                </div>
                                            ) }
                                            
                                            
                                            </>
                                        
                                            )}
                                         <div className={styles['data-wrapper']}>
                                            <p className={styles.subtitle}>Содержимое рассылки:</p>
                                            <p>{text}</p>
                                        </div>   
                                        <div className={styles['data-wrapper']}>
                                            <p className={styles.subtitle}>Дата отправки:</p>
                                            <p>{date}</p>
                                        </div>
                                    </div>
                                    <div className={styles['mailing-item-stat']}>
                                        <div>
                                            <strong>{data.receivers}</strong>
                                            <p>получателей</p>
                                        </div>
                                        <div>
                                            <strong>{data.success_receivers}</strong>
                                            <p>доставлено</p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                               
                            );
                        }).reverse()}
                    </>
                ) : (
                    
                    <>
                        
                            <p>Вы еще не создали ниодной рассылки!</p>
                    </>
                )}
                
            </div>
          
        </>
    );
};

export default MailingArchive;